// For more on svg icons and react -> https://css-tricks.com/creating-svg-icon-system-react/
// Link below explains could how to take svg and convert into react component and remove manual steps.
// https://medium.com/@scbarrus/transform-raw-svg-files-into-react-components-in-seconds-25faf56a6f07
// Short version:
// run: npm install -g svg-to-react-cli
// nav to ...ui/icons and run: svgtoreact dir
// svg icons will now be react components.

import { Addons } from './Addons';
import ArrowDropDown from './ArrowDropDown';
import ArrowIcon from './arrow-icon';
import AvailabilityRuleIcon from './availability-rule-icon';
import BlockedIcon from './blocked-icon';
import BlockedRecurringRuleIcon from './blocked-recurring-rule-icon';
import BlockedRuleIcon from './blocked-rule-icon';
import CalendarBookingIcon from './CalendarBookingIcon';
import CalendarIcon from './calendar-icon';
import CalendarOverrideIcon from './calendar-override-icon';
import CalendarShadedIcon from './calendar-shaded-icon';
import CannotEditIcon from './cannot-edit-icon';
import ChatBubbleSearchGraphic from './ChatBubbleSearchGraphic';
import Circle from './circle';
import CirclePlusIcon from './circle-plus-icon';
import CircleTimesIcon from './circle-times-icon';
import DownArrowIcon from './down-arrow-icon';
import Download from './Download';
import Explorer from './Explorer';
import ExternalLinkIcon from './ExternalLinkIcon';
import Favorite from './Favorite';
import ForwardChevron from './ForwardChevron';
import LightbulbIcon from './lightbulb-icon';
import LocationIcon from './location-icon';
import MoreIcon from './MoreIcon';
import OverrideRuleIcon from './override-rule-icon';
import { PinpointFeedback } from './PinpointFeedback';
import PrinterIcon from './printer-icon';
import PrivateIcon from './private-icon';
import PublicIcon from './public-icon';
import RecurringIcon from './recurring-icon';
import RecurringRuleIcon from './recurring-rule-icon';
import ResourcesIcon from './resources-icon';
import Share from './Share';
import WarningIcon from './Warning';
import XCircleIcon from './x-circle-icon';
import IcNavChevronIcon from './ic-nav-chevron-icon';

export {
  Addons,
  ArrowDropDown,
  ArrowIcon,
  AvailabilityRuleIcon,
  BlockedIcon,
  BlockedRecurringRuleIcon,
  BlockedRuleIcon,
  CalendarBookingIcon,
  CalendarIcon,
  CalendarOverrideIcon,
  CalendarShadedIcon,
  CannotEditIcon,
  ChatBubbleSearchGraphic,
  Circle,
  CirclePlusIcon,
  CircleTimesIcon,
  DownArrowIcon,
  Download,
  Explorer,
  ExternalLinkIcon,
  Favorite,
  ForwardChevron,
  LightbulbIcon,
  LocationIcon,
  MoreIcon,
  OverrideRuleIcon,
  PinpointFeedback,
  PrinterIcon,
  PrivateIcon,
  PublicIcon,
  RecurringIcon,
  RecurringRuleIcon,
  ResourcesIcon,
  Share,
  WarningIcon,
  XCircleIcon,
  IcNavChevronIcon,
};
